/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useDeleteRoute = () =>
  useMutation({
    mutationFn: (routeId: any) =>
      client(`resources/routes/${routeId}`, {
        method: "delete",
        successMessage: "Route has been deleted successfully",
      }),
  });
export const useGenerateRoster = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/daily/roster`, {
        data,
        successMessage: "Roaster has been generated successfully",
      }),
  });

export const useGetAllRoutes = () =>
  useMutation({
    mutationFn: (data: any) => client(`resources/routes`, { data }),
  });

export const useUpdateRoutesTeam = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/update/field/team`, {
        data,
        successMessage: "Route has been updated successfully",
      }),
  });
export const useGetRouteDetails = () =>
  useMutation({
    mutationFn: (routeNo: any) =>
      client(`resources/routes/filter/${routeNo}`, { hideError: true }),
  });
